function initCoupons(form) {
	const input = form.querySelector('[data-form="couponInput"]');
	const output = form.querySelector('[data-form="coupon"]');

	if (!(input && output)) {
		return;
	}

	input.addEventListener(
		'keyup',
		() => {
			const prefix = input.value
				.replace(/[^a-zA-Z0-9-]+/g, '')
				.toUpperCase()
				.substring(0, 3);
			const coupon = output.value.replace(/(.*?)-/, `${prefix}-`);

			output.value = coupon;
		},
		false
	);
}

export { initCoupons };
